<template>
  <div :class="$forms.stepperContainer">
    <app-loader :show-loader="getLoadingStatus" />

    <app-delete-dialog :value="deleteDialog"
                       @delete="deleteRealEstateItem(deleteId)"
                       @close="closeDialog">
      Are you sure you want to delete this real estate?
    </app-delete-dialog>

    <div :class="$forms.formMainContainer">
      <h2>Real Estate</h2>
      <p>
        Add, Edit or Delete any Real Estate Properties you currently own or
        owned the last time you filed.
      </p>

      <form>
        <div :class="$style.realEstateInfo">

          <app-data-table
            table-title="List of Real Estate"
            add-button="+ Add Real Estate"
            :headers="realEstateHeaders"
            :items="getRealEstate"
            @addNew="displayAddRealEstateSidebar"
            empty-text="There is currently no real estate added yet.
                        Please click on ‘+Add Real Estate’ to start adding new property."
          >
            <template v-slot:tableRows>
              <tr v-for="item in getRealEstate"
                  :key="item.id"
                  :class="$forms.tableDataRow">
                <td :class="$forms.description"
                    @click="showDetails(item.id)">
                  {{ item.residenceType | displayResidenceType }}
                </td>
                <td>{{ getLocation(item) }}</td>
                <td>{{ item.balanceOwed | currency }}</td>
                <td>
                  <template v-if="item.isPrimaryResidence">Yes</template>
                  <template v-else>No</template>
                </td>
                <td>
                  <template v-if="item.isRentalIncomeProperty">Yes</template>
                  <template v-else>No</template>
                </td>
                <td :class="$forms.tableRowButtons">
                  <button :class="$forms.tableBtn"
                          @click.prevent="showDialog(item.id)">
                    <app-svg-icon name="ic_delete" :class="$forms.tableIconDelete" />
                  </button>
                </td>
                <td :class="$forms.tableRowButtons">
                  <button :class="$forms.tableBtn" @click.prevent="editRealEstate(item.id)">
                    <app-svg-icon name="ic_edit@3x" :class="$forms.tableIconEdit" />
                  </button>
                </td>
              </tr>
            </template>
          </app-data-table>

        </div>

      </form>
    </div>
  </div>
</template>

<script>
import currency from 'currency.js';
import { mapGetters, mapActions } from 'vuex';
import formsMixin from '@/app/core/mixins/forms-mixin';
import { RESIDENCE_TYPES } from '@/constants';

export default {
  data() {
    return {
      step: 3,
      isInvalid: false,
      realEstateHeaders: [
        'Description',
        'Location',
        'Current Balance',
        'Primary Residence?',
        'Rental Property?',
      ],
      deleteDialog: false,
      deleteId: 0,
    };
  },
  methods: {
    ...mapActions([
      'deleteRealEstate',
      'realEstateItemRequest',
      'countiesRequest',
    ]),
    displayAddRealEstateSidebar() {
      this.$emit('displayRealEstateSidebar');
    },
    showDialog(id) {
      this.deleteDialog = true;
      this.deleteId = id;
    },
    closeDialog() {
      this.deleteDialog = false;
      this.deleteId = 0;
    },
    /* Delete real estate item by click at the Delete button in the dialog */
    deleteRealEstateItem(id) {
      this.deleteRealEstate({
        id,
        userId: this.getUserId,
      }).then(() => this.closeDialog());
    },
    /* Here we don't need to send any data - we
      just emit the confirmation to go to the next step */
    sendFormData() {
      this.$emit('nextStepDone', this.currentStep);
    },
    editRealEstate(id) {
      this.realEstateItemRequest({
        itemId: id,
        userId: this.getUserId,
      }).then(() => {
        this.$emit('editRealEstate', this.getItemDetails, id);
      });
    },
    /* Show Details sidebar */
    showDetails(id) {
      this.realEstateItemRequest({
        itemId: id,
        userId: this.getUserId,
      }).then(() => {
        this.$emit('showDetails', this.getItemDetails);
      });
    },
    getLocation(item) {
      return `${item.stateAbbreviation}, ${item.city}, ${item.countyName}`;
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getItemDetails',
      'getRealEstate',
      'getRealEstateLoadingStatus',
      'getCountiesOfState',
    ]),
    getResidenceTypes() {
      return RESIDENCE_TYPES.map(type => type.textValue);
    },
    getLoadingStatus() {
      return this.getRealEstateLoadingStatus === 'loading';
    },
    getInvalid() {
      return this.isInvalid;
    },
  },
  mixins: [
    formsMixin,
  ],
  directives: {
    currency,
  },
  filters: {
    displayResidenceType(value) {
      return RESIDENCE_TYPES.find(type => type.code === value).textValue;
    },
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>
@import "@/styles/variables.scss";

</style>
